import { createFileRoute } from '@tanstack/react-router'
import { WissenArticlePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/fr/savoir/$articleSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'article', locale: 'fr', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { articleSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <WissenArticlePage articleSlug={articleSlug} />
    </CatalogProvider>
  )
}
